module.exports = __webpack_public_path__ + "static/media/Dp.813d594d.webp";